import { useCallback, useMemo, useState } from "react";
import FormikCreatableSelect from "./FormikCreatableSelect";

const FormikCreatableField = ({
  name,
  label,
  formik,
  data = [],
  isLoading = false,
  placeholder = "Select Option",
  required = false,
  valueKey = "id",
  labelKey = "name",
  onChange, // 👈 external custom change handler
}) => {
  const [createdItems, setCreatedItems] = useState([]);

  const options = useMemo(() => {
    const rawItems = data ?? [];
    const combined = [...rawItems, ...createdItems];

    return combined.map(item => ({
      value: item[valueKey]?.toString(),
      label: item[labelKey],
      raw: item, // 👈 keep original item for advanced usage
    }));
  }, [data, createdItems, valueKey, labelKey]);

  const handleCreateOption = useCallback(
    (inputValue) => {
      const tempId = `new_${Date.now()}_${Math.random()
        .toString(36)
        .substr(2, 9)}`;

      const newItem = {
        [valueKey]: tempId,
        [labelKey]: inputValue,
      };

      setCreatedItems(prev => [...prev, newItem]);

      // auto select after create
      formik.setFieldValue(name, tempId);

      // allow parent to react
      onChange?.(tempId, newItem);
    },
    [valueKey, labelKey, formik, name, onChange]
  );

  const handleChange = useCallback(
    (selectedValue) => {
      formik.setFieldValue(name, selectedValue);

      const selectedItem = [...data, ...createdItems].find(
        item => item[valueKey]?.toString() === selectedValue
      );

      onChange?.(selectedValue, selectedItem);
    },
    [formik, name, data, createdItems, valueKey, onChange]
  );

  return (
    <FormikCreatableSelect
      name={name}
      label={label}
      formik={formik}
      options={options}
      placeholder={placeholder}
      loading={isLoading}
      required={required}
      onCreateOption={handleCreateOption}
      onChange={handleChange}
    />
  );
};

export default FormikCreatableField;
